/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamRevisionReview202,
  PostApiV1ExamRevisionReview400,
  PostApiV1ExamRevisionReview401,
  PostApiV1ExamRevisionReview500,
  PostApiV1ExamRevisionReviewMutationRequest,
  PostApiV1ExamRevisionReviewMutationResponse,
} from "../../types/examRevisionController/PostApiV1ExamRevisionReview.ts";
import { classroomDisciplineBotExamReviewViewModelSchema } from "../classroomDisciplineBotExamReviewViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ExamRevisionReview202Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionReview202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ExamRevisionReview400Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionReview400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamRevisionReview401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionReview401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamRevisionReview500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionReview500>;

export const postApiV1ExamRevisionReviewMutationRequestSchema = z.lazy(
  () => classroomDisciplineBotExamReviewViewModelSchema,
) as unknown as ToZod<PostApiV1ExamRevisionReviewMutationRequest>;

export const postApiV1ExamRevisionReviewMutationResponseSchema = z.lazy(
  () => postApiV1ExamRevisionReview202Schema,
) as unknown as ToZod<PostApiV1ExamRevisionReviewMutationResponse>;
